interface BridgeApiMeta {
  [key: string]: (...args: any[]) => void;
}

export interface HaiLuoH5BridgeMeta {
  callJs: (params: string) => void;
  onCallJsResult: (params: string) => void;
  bridgeApi: BridgeApiMeta; // 所有的方法封装
}

interface CallBridgeBaseApiParams {
  methodName: string; // 方法名 必填
  params?: any; // 方法调用如果需要参数，通过此参数，传递 选填
  callbackId?: string;
}

interface CallBridgeCallbackApiParams {
  callbackId: string;
  params?: {
    errCode: number;
    errMsg: string;
    data: any;
  };
}

// 客户端调用前端
const callH5Bridge = () => {
  const initHailuoH5Bridge = () => {
    if (!window.hailuoH5Bridge) {
      window.hailuoH5Bridge = {
        callJs: initCallJs,
        onCallJsResult: initOnCallJsResult,
        bridgeApi: {}, // 所有的方法封装
      } as HaiLuoH5BridgeMeta;
    }
  };

  const isJson = (jsonString: string) => {
    let isJson = false;
    try {
      JSON.parse(jsonString);
      isJson = true;
    } catch (err) {
      isJson = false;
    }
    return isJson;
  };

  const initCallJs = (nativeParamsStringify: string) => {
    if (!nativeParamsStringify || !isJson(nativeParamsStringify)) {
      return;
    }
    const { methodName, params, callbackId } = JSON.parse(
      nativeParamsStringify,
    ) as CallBridgeBaseApiParams;
    try {
      if (!window.hailuoH5Bridge.bridgeApi?.[methodName]) {
        throw Error('h5 method ' + methodName + '不存在 ');
      }
      window.hailuoH5Bridge.bridgeApi[methodName](params, callbackId);
    } catch (err) {
      console.log(err);
      // todo 前端 调用客户端 callbackId 执行 on Error
    }
  };

  const initOnCallJsResult = (nativeParamsStringify: string) => {
    if (!nativeParamsStringify || !isJson(nativeParamsStringify)) {
      return;
    }
    try {
      const { callbackId, params } = JSON.parse(
        nativeParamsStringify,
      ) as CallBridgeCallbackApiParams;
      if (!window.hailuoH5Bridge.bridgeApi?.[callbackId]) {
        throw Error('h5 method ' + callbackId + '不存在');
      }
      window.hailuoH5Bridge.bridgeApi[callbackId](params);
    } catch (err) {
      console.log(err);
      // todo 前端 调用客户端 callbackId 执行 on Error
    }
  };

  /**
   * 注册 客户端调用web 方法，所有方法抽离在 hailuoH5Bridge 里面
   * 同时需要
   * * * hailuoH5Bridge.callJs
   * * * hailuoH5Bridge.onCallJsResult
   * 调用时机： 页面初始化时、bridge被异常销毁
   */
  const initAll = () => {
    if (!window.hailuoH5Bridge) {
      initHailuoH5Bridge();
      return;
    }
    if (!window.hailuoH5Bridge?.callJs) {
      window.hailuoH5Bridge.callJs = initCallJs;
    }
    if (!window.hailuoH5Bridge?.onCallJsResult) {
      window.hailuoH5Bridge.onCallJsResult = initOnCallJsResult;
    }
    if (!window.hailuoH5Bridge?.bridgeApi) {
      window.hailuoH5Bridge.bridgeApi = {};
    }
  };

  /**
   * 将方法注入到 window.hailuoH5Bridge.bridgeApi 里，方便客户端调用
   * 注入时机 页面初始化的时候 挂载需要和客户端通信的方法到window
   */
  const addBridgeApi = <T extends (...args: any[]) => void>(methodName: string, fn: T) => {
    if (!window.hailuoH5Bridge) {
      initAll();
    }
    window.hailuoH5Bridge.bridgeApi[methodName] = fn;
  };

  const batchAddBridgeApi = (apis: BridgeApiMeta) => {
    if (!window.hailuoH5Bridge) {
      initAll();
    }
    window.hailuoH5Bridge.bridgeApi = {
      ...window.hailuoH5Bridge.bridgeApi,
      ...apis,
    };
  };

  const clearH5Bridge = () => {
    if (window.hailuoH5Bridge) {
      // @ts-ignore
      delete window.hailuoH5Bridge;
    }
  };

  return {
    initAll,
    addBridgeApi,
    clearH5Bridge,
    batchAddBridgeApi,
  };
};

export const h5Bridge = callH5Bridge();
